import PropTypes from 'prop-types'

import { OccupationsIcon } from '@h2/components/icons/occupations'
import { CollegeIcon } from '@h2/components/icons/college'
import { InformationPageIcon } from '@h2/components/icons/informationPage'

const iconMap = {
  college: CollegeIcon,
  pages: InformationPageIcon,
  briefcase: OccupationsIcon
}
const types = /.(pages).|.(briefcase).|.(college)./
const Icon = ({ type, size = 'small' }) => {
  const matches = type.match(types)

  if (matches) {
    // Remove the matched string and filter the capturing groups
    const match = matches.slice(1).filter(Boolean).pop()
    const MatchedIcon = iconMap[match]

    return <MatchedIcon size={size} />
  }

  return null
}

Icon.propTypes = {
  size: PropTypes.oneOf(['tiny', 'small', 'medium']),
  type: PropTypes.string.isRequired
}

export { Icon }
